import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=7a357e6b&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"
import style0 from "./NoData.vue?vue&type=style&index=0&id=7a357e6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a357e6b",
  null
  
)

export default component.exports